var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComputerBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "heroicons:computer-desktop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tipping-Screens",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "heroicons:computer-desktop"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ViewBox",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,17.25 L9,18.257 C9.00009534,19.052931 8.68389317,19.8162768 8.121,20.379 L7.5,21 L16.5,21 L15.879,20.379 C15.3161068,19.8162768 14.9999047,19.052931 15,18.257 L15,17.25 M21,5.25 L21,15 C21,16.2426407 19.9926407,17.25 18.75,17.25 L5.25,17.25 C4.00735931,17.25 3,16.2426407 3,15 L3,5.25 M21,5.25 C21,4.00735931 19.9926407,3 18.75,3 L5.25,3 C4.00735931,3 3,4.00735931 3,5.25 M21,5.25 L21,12 C21,13.2426407 19.9926407,14.25 18.75,14.25 L5.25,14.25 C4.00735931,14.25 3,13.2426407 3,12 L3,5.25",
    id: "Shape",
    stroke: "#192340",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerBlack);
export default __webpack_public_path__ + "static/media/computer-black.85fe1c477c8cfbcb44f9730dffddc652.svg";
export { ForwardRef as ReactComponent };